import { useContext } from 'react';
import { storesContext } from '../contexts';

const useStores = () => {
    return useContext(storesContext);
};

export default useStores;
